import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './styles.scss';
import { APP_LOGO_INVERTED } from 'containers/App/constants';

import injectReducer from 'utils/injectReducer';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';

import reducer from 'containers/App/reducer';
import { makeSelectUser, makeSelectTokenValidation, featureAllowed } from 'containers/App/selectors';
import { logout } from 'containers/App/actions';
import Favicon from "react-favicon";
import configs from 'configs';
import { APP_MAIN_LOGO } from '../../containers/App/constants';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      dropdownOpen: false,
      color: 'transparent',
      chatbotLoaded: false,
      route: '',
    };
    this.toggle = this.toggle.bind(this);
    this.dropdownToggle = this.dropdownToggle.bind(this);
  }

  toggle() {
    if (this.state.isOpen) {
      this.setState({
        color: 'transparent',
      });
    } else {
      this.setState({
        color: 'white',
      });
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  dropdownToggle(e) {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  openSidebar() {
    document.documentElement.classList.toggle('nav-open');
    this.refs.sidebarToggle.classList.toggle('toggled');
  }

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor() {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
        color: 'white',
      });
    } else {
      this.setState({
        color: 'transparent',
      });
    }
  }

  initChatBot() {
    // vecchio ChatBot
    if (this.props.hasFaqSalesBot === true && !this.state.chatbotLoaded && process.env.CHATBOT_FAQ_ID) {
      const { user: {name, email, business_name, code} } = this.props;

      window.__be = window.__be || {};
      window.__be.id = process.env.CHATBOT_FAQ_ID;
      (function() {
          var be = document.createElement('script');
        be.type = 'text/javascript';
          be.async = true;
          be.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.chatbot.com/widget/plugin.js';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(be, s);
      })();

      window.BE_API = window.BE_API || {};

      const userAttributes = {
        name,
        email,
        business_name,
        id: code,
        default_name: name,
        default_username: name,
      };

      const sessionAttributes = {
        agent_name: name,
      };

      this.setState({chatbotLoaded: true});

      setTimeout(() => {
        if (window.BE_API && typeof window.BE_API.isInitialized === 'function' && window.BE_API.isInitialized() && window.BE_API.isChatWindowHidden()) {
          window.BE_API.resetSession()
        }
      }, 2000);

      window.BE_API.onChatWindowOpen = function () {
        try {
          window.BE_API.setSessionAttributes(sessionAttributes)
          window.BE_API.setUserAttributes(userAttributes)
        } catch (e) { }
      };

      window.BE_API.onSessionReset = () => {
        try {
          window.BE_API.setSessionAttributes(sessionAttributes)
          window.BE_API.setUserAttributes(userAttributes)
        } catch (e) { }
      }

    } else if (!this.props.hasFaqSalesBot && this.state.chatbotLoaded) {
      // window.BE_API.hideChatWindow();
      // this.setState({chatbotLoaded: false});
    }

    // nuovo Sales Assistant EuGenIA
    const { user: {bot_uuid} } = this.props;

    if (bot_uuid && bot_uuid !== '' && process.env.EUGENIA_CHATBOT_FRONTEND_URL && process.env.EUGENIA_CHATBOT_FRONTEND_URL !== '') {
      const  scriptExists = document.getElementById('eugenia-chatbot-embed');

      if (!scriptExists) {
        const botDomain = (new URL(configs.appUrl)).hostname;

        (function() {
          var sc = document.createElement('script');
          sc.type = 'text/javascript';
          sc.async = true;
          sc.id = 'eugenia-chatbot-embed';
          sc.src = process.env.EUGENIA_CHATBOT_FRONTEND_URL + '/embed.js';
          sc.setAttribute('widget-domain', process.env.EUGENIA_CHATBOT_FRONTEND_URL);
          sc.setAttribute('bot-domain', botDomain);
          sc.setAttribute('bot-key', bot_uuid);
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(sc, s);
        })();
      }
    }
  }

  routeChanged(currentRoute) {
    this.setState({ route: currentRoute });

    this.initChatBot();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateColor.bind(this));

    this.routeChanged(location.pathname);
  }

  componentDidUpdate() {
    if (location.pathname && location.pathname !== this.state.route) {
      this.routeChanged(location.pathname);
    }
  }

  onLogOut = () => {
    this.props.logout();
  };

  handleKeyboard = ev => {
    if (ev.keyCode === 13) {
      this.setState({ visibility: 'visible' });
      this.setState({ opacity: 1 });
    }
  };

  render() {
    const { user: {name, business_name, roleName, logo}, featureAllowed } = this.props;

    return (
      <div className="top-bar color-scheme-bright">
        <Favicon url={Object.values(configs.favicons)} animated={false} />

        <div className="logo-w menu-size">
          <Link className="logo" to="/">
            {featureAllowed('rebrand') && logo ?
              <img src={logo} alt="Logo" />
              :
              <img src={APP_MAIN_LOGO} alt="Logo" />
            }
          </Link>
        </div>
        <div className="logged-user-w avatar-inline">
          <div className="logged-user-i" tabIndex={0} onKeyDown={this.handleKeyboard}>
            <div className="logged-user-info-w">
              <div className="logged-user-name">{name || business_name}</div>
              <div className="logged-user-role">{roleName}</div>
            </div>
            <div className="logged-user-toggler-arrow">
              <div className="os-icon os-icon-chevron-down" />
            </div>
            <div className="logged-user-menu color-style-bright" style={{visibility: this.state.visibility, opacity: this.state.opacity }}>
              <div className="logged-user-avatar-info">
                <div className="logged-user-info-w">
                  <div className="logged-user-name">{name || business_name}</div>
                  <div className="logged-user-role">{roleName}</div>
                </div>
              </div>
              <div className="bg-icon">
                <i className="os-icon os-icon-wallet-loaded" />
              </div>
              <ul>
                <li tabIndex={0}>
                  <a href="/profile" aria-label={'Profilo'}>
                    <i className="os-icon os-icon-user-male-circle2" />
                    <span>Profilo</span>
                  </a>
                </li>
                <li tabIndex={0}>
                  <a
                    aria-label="Log out"
                    style={{ cursor: 'pointer' }}
                    onClick={this.onLogOut}
                  >
                    <i className="os-icon os-icon-signs-11" />
                    <span>Log out</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout()),
  };
}

const withReducer = injectReducer({ key: 'user', reducer });

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  isTokenInvalid: makeSelectTokenValidation(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

Header.defaultProps = {
  hasFaqSalesBot: false,
};

Header.propTypes = {
  user: PropTypes.object,
  hasFaqSalesBot: PropTypes.bool,
};

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withConnect,
)(Header);
